var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36,21.5H0v-3.794h36V21.5z M36,12.647H0V8.853h36V12.647z M36,3.794H0V0h36V3.794z"}));
}

MenuInline.defaultProps = {"version":"1.1","id":"Livello_1","x":"0px","y":"0px","width":"36px","height":"21.5px","viewBox":"0 0 36 21.5","enableBackground":"new 0 0 36 21.5","xmlSpace":"preserve"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
